"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Attachment = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_base64Binary_1 = require("../Scalar/RTTI_base64Binary");
var RTTI_url_1 = require("../Scalar/RTTI_url");
var RTTI_unsignedInt_1 = require("../Scalar/RTTI_unsignedInt");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
exports.RTTI_Attachment = t.recursion('IAttachment', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        contentType: RTTI_code_1.RTTI_code,
        _contentType: RTTI_Element_1.RTTI_Element,
        language: RTTI_code_1.RTTI_code,
        _language: RTTI_Element_1.RTTI_Element,
        data: RTTI_base64Binary_1.RTTI_base64Binary,
        _data: RTTI_Element_1.RTTI_Element,
        url: RTTI_url_1.RTTI_url,
        _url: RTTI_Element_1.RTTI_Element,
        size: RTTI_unsignedInt_1.RTTI_unsignedInt,
        _size: RTTI_Element_1.RTTI_Element,
        hash: RTTI_base64Binary_1.RTTI_base64Binary,
        _hash: RTTI_Element_1.RTTI_Element,
        title: t.string,
        _title: RTTI_Element_1.RTTI_Element,
        creation: RTTI_dateTime_1.RTTI_dateTime,
        _creation: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_Attachment.js.map